
// Edit Section A : Add field from FormField boiler plate library

import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardFormHorizontalThird } from '../../widgets/Cards';

import { editMHProfile, newMHProfile, fetchMHProfiles } from '../../../actions';

class MHProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchMHProfiles(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchMHProfiles(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].mentalhealth;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }

    MHProfileForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;

        // Change Actions below
            this.props.newMHProfile(form);
        }

        const required = value =>(value ? undefined : 'Required');

        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit} >
                            <div className='header'>Mental Health Profile</div>

                            <div className='form-4-columns'>
                                <div>
                                    <Field name="date" component='input' label="Date" validate={required}>
                                        {({input, meta}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Date</label>
                                                    <input size='30' {...input} type='date' />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                        )} 
                                    </Field>
                                    <Field name='mentalhx' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Mental Health History</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='personality' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Premorbid Personality</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='familyhx' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Family History of Mental Health</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    </div>
                                    <div>
                                    <Field name='socialhx' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Social History</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='develophx' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Developmental History</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='domestic' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Domestic</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    </div>
                                    <div>
                                    <Field name='substance' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Substance and Alcohol History</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='treatmenthx' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Treatment History</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='housing' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Current and Past Housing</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    </div>
                                    <div>
                                    <Field name='finance' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Current and Past Financial Condition</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='employment' component='input' validate={required} placeholder=''>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Current and Past Employment History</label>
                                                <textarea cols="50" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                </div>
                    
                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button type='button' onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardFormHorizontalThird content={this.MHProfileForm()}>
            </CardFormHorizontalThird>
        )
    }
}


const mapStateToProps = (state) => {

    return { 
             patient : state.selectedPatient,
             content : Object.values(state.mh_profiles),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editMHProfile, newMHProfile, fetchMHProfiles})(MHProfile);
